import React from 'react';
import { Box, Button, Dropdown, Select, Image, Alert, Typography, Grid, TextField, Calendar } from '@iho-design-system/Loader';
import moment from 'jalali-moment';




import CalendarSVG from '../../assets/images/icons/calendar.svg';
import profileImg from '../../assets/images/icons/user-profile.svg';
import iconDownSVG from '../../assets/images/icons/chevron-down.svg';
import getAPI from './../../api/get';
import AgencyProfile from '../../api/edit/AgencyProfile';


const BaseInfo = (props) => {
    const [Errs, setErrs] = React.useState(['']);
    const [Success, setSuccess] = React.useState(false);
    const [states, setStates] = React.useState([])
    const [cities, setCities] = React.useState([])
    const [RegisterDateInfo, setRegisterDateInfo] = React.useState('');
    const [getDataBaseB2B, setDataBaseB2B] = React.useState({
        Address: "",
        BrandName: "",
        City: '0',
        Confirmed: false,
        Country: '0',
        Email: "",
        Fax: "",
        IATACode: "",
        MobileNumber: "",
        Name: "",
        NationalId: "",
        Phone: "",
        PostalCode: "",
        RegisterDate: "",
        RegisterNumber: "",
        State: '0',
        UserType: 1,
        ValueAddedId: "",
        WebsiteUrl: ""
    })
    const typeUser = localStorage.getItem('userType');
  

    let nameLbl = '';
    let EmailLbl = '';

    switch (typeUser) {
        case '1':
            nameLbl = 'نام آژانس	';
            EmailLbl = 'ایمیل آژانس	';
            break;
        case '2':
            nameLbl = 'نام رسمی سازمان	';
            EmailLbl = 'ایمیل سازمان	';
            break;
        case '3':
            nameLbl = 'نام و نام خانوادگی	';
            EmailLbl = 'ایمیل سازمان	';
            break;

        default:
            break;
    }


    /*
       - alert
   */
    const [alert, setAlert] = React.useState('');
    const [alertColor, setAlertColor] = React.useState('success');
    const [alertStatus, setAlertStatus] = React.useState('d-none');
    const alertProps = (config) => {
        setAlert(config[1])
        setAlertColor(config[0]);
        setAlertStatus('d-flex');
        setTimeout(() => {
            setAlertStatus('d-none');
        }, 5000);
    }

    /*
           - toggleBox
       */
    const toggleBox = (className) => {

        document.querySelector(`.${className}`).classList.toggle('d-none');
        if (document.querySelector(`.${className}`).classList[4] === undefined) {
            document.querySelector(`.chevran-down`).style.rotate = '180deg';
        } else {
            document.querySelector(`.chevran-down`).style.rotate = '0deg';
        }
    }



    /*
         - toggleCaldendar
     */
    const toggleCalendar = (event, calendar) => {
        if (event.target.tagName === 'INPUT' && calendar === 'RegisterDate') {
            setRegisterDateInfo('');
        }


        if (event.target.tagName === 'DIV' || event.target.tagName === 'INPUT') {
            document.querySelector(`.${calendar}`).classList.toggle('d-none');
        }
    }

    /*
        API
    */





    const [Country, setCountry] = React.useState([])
    React.useEffect(() => {
        const fetchData = async () => {

            let citiesAndStatesParameters = {
                ctrl: 'Common',
                method: 'StateAndCities',
                query: ''
            }
            let countryParameters = {
                ctrl: 'Common',
                method: 'GetAllCountries',
                query: ''
            }

            let userTypeParameters = {
                ctrl: 'AgencyProfile',
                method: '',
                query: ''
            }
            const fetchCityAndState = await getAPI(citiesAndStatesParameters);
            const fetchCountry = await getAPI(countryParameters);



            fetchCityAndState.data.forEach((obj) => {
                let helper = {};
                helper.id = obj.id;
                helper.title = obj.title
                states.push(helper);
            });

            fetchCityAndState.data.forEach((parentObj) => {
                states.forEach((childObj) => {
                    if (parentObj.id === childObj.id) {
                        parentObj.cities.forEach((grandchildObj) => {
                            grandchildObj.stateId = childObj.id;
                            cities.push(grandchildObj);
                        });
                    }
                })
            });


            switch (typeUser) {
                case '1':
                    userTypeParameters.method = 'GetAgencyBaseInfo';
                    break;
                case '2':
                    userTypeParameters.method = 'GetOrganizationBaseInfo';
                    break;
                case '3':
                    userTypeParameters.method = 'GetIndividualBaseInfo';
                    break;

                default:
                    break;
            }


            let response = await getAPI(userTypeParameters);
            if (response.status == 200) {
                setDataBaseB2B({ //response.data
                    ...response.data
                });


            }
            // setCountry(fetchCountry.filter(item => item.Id == getDataBaseB2B.Country));
            fetchCountry.data.forEach((obj) => {
                let helper = {};
                helper.id = obj.Id;
                helper.title = obj.Name
                Country.push(helper);
            });


            setRegisterDateInfo(response.data.RegisterDate ? moment(response.data.RegisterDate.split('T'), 'YYYY-MM-DD').locale('fa').format('YYYY/MM/DD') : '');
        }
        fetchData();
    }, []);

    /*
         - editUserProfileHandler
     */
    const editProfileHandler = (key, value) => {


        switch (key) {
            case 'BrandName':


                setDataBaseB2B({
                    ...getDataBaseB2B,
                    BrandName: value
                })
                break;
            case 'Address':
                setDataBaseB2B({
                    ...getDataBaseB2B,
                    Address: value
                })
                break;
            case 'City':
                setDataBaseB2B({
                    ...getDataBaseB2B,
                    City: value
                })
                break;
            case 'Country':
                setDataBaseB2B({
                    ...getDataBaseB2B,
                    Country: value
                })
                break;
            case 'State':
                setDataBaseB2B({
                    ...getDataBaseB2B,
                    State: value
                })
                break;
            case 'Email':
                setDataBaseB2B({
                    ...getDataBaseB2B,
                    Email: value
                })
                break;
            case 'Fax':
                setDataBaseB2B({
                    ...getDataBaseB2B,
                    Fax: value
                })
                break;
            case 'IATACode':
                setDataBaseB2B({
                    ...getDataBaseB2B,
                    IATACode: value
                })
                break;
            case 'NationalId':
                setDataBaseB2B({
                    ...getDataBaseB2B,
                    NationalId: value
                })
                break;
            case 'Phone':
                setDataBaseB2B({
                    ...getDataBaseB2B,
                    Phone: value
                })
                break;
            case 'WebsiteUrl':
                setDataBaseB2B({
                    ...getDataBaseB2B,
                    WebsiteUrl: value
                })
                break;
            case 'ValueAddedId':
                setDataBaseB2B({
                    ...getDataBaseB2B,
                    ValueAddedId: value
                })
                break;
            case 'PostalCode':
                setDataBaseB2B({
                    ...getDataBaseB2B,
                    PostalCode: value
                })
                break;
            case 'RegisterDate':

                setRegisterDateInfo(value);
                setDataBaseB2B((prevState) => ({
                    ...prevState,
                    RegisterDate: moment.from(value, 'fa', 'YYYY/MM/DD').format('YYYY-MM-DD')
                }))

                break;
            case 'RegisterNumber':
                setDataBaseB2B({
                    ...getDataBaseB2B,
                    RegisterNumber: value
                })
                break;



            default:
                break;
        }


    }


    const handleSubmit = async (e) => {
        
        e.preventDefault();
        let method = '';
        setErrs(['']);
        switch (typeUser) {
            case '1':
                method = 'SaveAgencyBaseInfo';
                break;
            case '2':
                method = 'SaveOrganizationBaseInfo';
                break;
            case '3':
                method = 'SaveIndividualBaseInfo';
                break;

            default:
                break;
        }

        let isSend = true;
        const regex = new RegExp('(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?');
        
        if (getDataBaseB2B.WebsiteUrl && !regex.test(getDataBaseB2B.WebsiteUrl)) {
            alertProps(['danger', 'فرمت وبسایت درست وارد شود ']);
            return;
        }
        

        if (!getDataBaseB2B.BrandName || getDataBaseB2B.BrandName == '') {
            setErrs(prevErrors => [...prevErrors, 'نام برند نباید خالی باشد']);
           
            isSend = false;
        }
        if (!getDataBaseB2B.NationalId || getDataBaseB2B.NationalId == '') {
            setErrs(prevErrors => [...prevErrors, 'کد ملی نباید خالی باشد']);
           
            isSend = false;
        }
        if (!getDataBaseB2B.RegisterNumber || getDataBaseB2B.RegisterNumber == '') {
            setErrs(prevErrors => [...prevErrors, 'شماره ثبت نباید خالی باشد']);
           
            isSend = false;
        }
        if (!getDataBaseB2B.ValueAddedId || getDataBaseB2B.ValueAddedId == '') {
            setErrs(prevErrors => [...prevErrors, 'شناسه ارزش افزوده نباید خالی باشد']);
         
            isSend = false;
        }
        if (!getDataBaseB2B.Phone || getDataBaseB2B.Phone == '') {
            setErrs(prevErrors => [...prevErrors, '  تلفن ثابت نباید خالی باشد']);
           
            isSend = false;
        }
        if (!getDataBaseB2B.Fax || getDataBaseB2B.Fax == '') {
            setErrs(prevErrors => [...prevErrors, '   فکس نباید خالی باشد']);
           
            isSend = false;
        }
        if (!getDataBaseB2B.PostalCode || getDataBaseB2B.PostalCode == '') {
            setErrs(prevErrors => [...prevErrors, '   کدپستی نباید خالی باشد']);
           
            isSend = false;
        }
        if (!getDataBaseB2B.Address || getDataBaseB2B.Address == '') {
            setErrs(prevErrors => [...prevErrors, '   آدرس نباید خالی باشد']);
           
            isSend = false;
        }

        if (!getDataBaseB2B.Country || getDataBaseB2B.Country == '0') {
            setErrs(prevErrors => [...prevErrors, 'کشور نباید خالی باشد']);

          
            isSend = false;
        }

        if (!getDataBaseB2B.State || getDataBaseB2B.State == '0') {
            setErrs(prevErrors => [...prevErrors, 'استان نباید خالی باشد']);

           
            isSend = false;
        }
        let result = await AgencyProfile(method, getDataBaseB2B);
        window.scrollTo(0,0);
        setErrs([]);
        if (result.status === 'success') {
            alertProps(['success', 'با موفقیت ثبت شد']);
            setSuccess(true);

        } else {
            if (result.data.Errors) {
                setSuccess(false);
                // let itemErr = '';
                result.data.Errors.forEach(item => {
                    //   const itemErr = item.toString();
                    setErrs(prevErrors => [...prevErrors, item]);
                    alertProps(['danger', item]);
                })
            }

        if (!getDataBaseB2B.City || getDataBaseB2B.City == '0') {
            setErrs(prevErrors => [...prevErrors, 'شهر نباید خالی باشد']);
           
            isSend = false;
        }


        if(isSend){
            let result = await AgencyProfile(method, getDataBaseB2B);
            window.scrollTo(0,0);
            setErrs(['']);
            if (result.status === 'success') {
                alertProps(['success', 'با موفقیت ثبت شد']);
                setSuccess(true);
    
            } else {
                if (result.data.Errors) {
                    setSuccess(false);
    
                    // let itemErr = '';
                    result.data.Errors.forEach(item => {
                        //   const itemErr = item.toString();
                        setErrs(prevErrors => [...prevErrors, item]);
                        alertProps(['danger', item]);
    
                    });
    
    
                } else {
                    setSuccess(false);
                    alertProps(['danger', result.data.Message]);
                }
            }
        }else{
            alertProps(['danger', Errs]);
            
        }
       
    }
}


    

    const resetForm = () => {

        setDataBaseB2B((prevState) => ({
            ...prevState,
            Address: "",
            BrandName: "",
            City: '0',
            Confirmed: false,
            Country: '0',
            Fax: "",
            IATACode: "",
            NationalId: "",
            Phone: "",
            PostalCode: "",
            RegisterDate: "",
            RegisterNumber: "",
            State: '0',
            UserType: 1,
            ValueAddedId: "",
            WebsiteUrl: ""
        }));
        setErrs(['']);
    }

    return (
        <React.Fragment>
           
            <form

                onSubmit={handleSubmit}
                method="POST"
            >
                <Box
                    className={`bg-white rounded-lg border-solid border-light p-xl`}>

                    <Grid>
                        <Grid.Wrapper>
                            <Grid.Item
                                size='col-8'>
                                <Grid.Wrapper>
                                    <Grid.Item
                                        className={`border-solid-bottom border-light`}
                                        size='col-12'>
                                        <Typography ms={{
                                            fontWeight: 'bold'
                                        }}>
                                            اطلاعات عمومی
                                        </Typography>
                                    </Grid.Item>
                                    <Grid.Item
                                        size='col-6'>
                                        <TextField
                                            className={`disabled `}
                                            disabled
                                            value={props.typeUser}
                                            label='  نوع '
                                        />
                                    </Grid.Item>
                                    <Grid.Item
                                        size='col-6'>

                                        <TextField
                                            value={getDataBaseB2B.Name ? getDataBaseB2B.Name : ''}
                                            className={`disabled `}
                                            disabled


                                            label={nameLbl}


                                        />

                                    </Grid.Item>
                                    <Grid.Item
                                        size='col-6'>
                                        <TextField
                                            value={getDataBaseB2B.BrandName ? getDataBaseB2B.BrandName : ''}
                                            onChange={(event) => editProfileHandler('BrandName', event)}

                                            label='  نام برند '


                                        />
                                    </Grid.Item>
                                    <Grid.Item
                                        size='col-6'>
                                        <TextField
                                            className={`disabled `}
                                            disabled
                                            value={getDataBaseB2B.MobileNumber ? getDataBaseB2B.MobileNumber : ''}
                                            // onChange={(event) => editBankAccountHandler('accountName', event)}

                                            label='  شماره همراه حساب کاربری '


                                        />
                                    </Grid.Item>
                                    <Grid.Item
                                        size='col-6'>
                                        <TextField
                                            value={getDataBaseB2B.Email ? getDataBaseB2B.Email : ''}
                                            disabled
                                            className={`disabled `}
                                            onChange={(event) => editProfileHandler('Email', event)}
                                            label={EmailLbl}
                                        />



                                    </Grid.Item>
                                    <Grid.Item
                                        size='col-6'>
                                        {typeUser == 3 && <TextField
                                            value={getDataBaseB2B.NationalId ? getDataBaseB2B.NationalId : ''}
                                            onChange={(event) => editProfileHandler('NationalId', event)}
                                            label='  کد ملی '
                                            className={getDataBaseB2B.Confirmed == true ? 'disabled' : ''}
                                            disabled={getDataBaseB2B.Confirmed == true ? true : false}
                                        //{...(getDataBaseB2B.Confirmed && { disabled: true })}
                                        />}
                                        {(typeUser == 1 || typeUser == 2) && <TextField
                                            value={getDataBaseB2B.NationalId ? getDataBaseB2B.NationalId : ''}
                                            onChange={(event) => editProfileHandler('NationalId', event)}
                                            label='  شناسه ملی '
                                            className={getDataBaseB2B.Confirmed == true ? 'disabled' : ''}
                                            disabled={getDataBaseB2B.Confirmed == true ? true : false}

                                        />
                                        }
                                    </Grid.Item>
                                    {(typeUser == 1 || typeUser == 2) &&
                                        <Grid.Item
                                            size='col-6'>
                                            <TextField
                                                value={getDataBaseB2B.RegisterNumber ? getDataBaseB2B.RegisterNumber : ''}
                                                onChange={(event) => editProfileHandler('RegisterNumber', event)}
                                                className={getDataBaseB2B.Confirmed == true ? 'disabled' : ''}
                                                disabled={getDataBaseB2B.Confirmed == true ? true : false}
                                                label='  شماره ثبت '


                                            />
                                        </Grid.Item>
                                    }
                                    {(typeUser == 1 || typeUser == 2) &&
                                        <Grid.Item
                                            size='col-6'>
                                            <TextField
                                                value={getDataBaseB2B.ValueAddedId ? getDataBaseB2B.ValueAddedId : ''}
                                                onChange={(event) => editProfileHandler('ValueAddedId', event)}
                                                label='  شناسه ارزش افزوده '
                                                className={getDataBaseB2B.Confirmed == true ? 'disabled' : ''}
                                                disabled={getDataBaseB2B.Confirmed == true ? true : false}
                                            />
                                        </Grid.Item>
                                    }
                                    {(typeUser == 1 || typeUser == 2) && <Grid.Item
                                        className={`position-relative`}
                                        size='col-6'>


                                        <Box
                                            onClick={(event) => toggleCalendar(event, 'RegisterDate')}>
                                            <TextField
                                                label='تاریخ ثبت (اختیاری)'
                                                // onChange={(event) => toggleCalendar('RegisterDate', event)}
                                                icon={CalendarSVG}
                                                value={RegisterDateInfo ? RegisterDateInfo : ''}
                                            // value={RegisterDate}
                                            />

                                            <Box
                                                className={`RegisterDate d-none position-absolute`}
                                                ms={{
                                                    width: '320px',
                                                    top: 'calc(75px + var(--sizing-xs))',
                                                    zIndex: '1'
                                                }}>
                                                <Calendar
                                                    onChange={(event) => editProfileHandler('RegisterDate', event)} />
                                            </Box>
                                        </Box>
                                    </Grid.Item>
                                    }

                                    <Grid.Item
                                        size='col-6'>
                                        <TextField
                                            value={getDataBaseB2B.WebsiteUrl ? getDataBaseB2B.WebsiteUrl : ''}
                                            onChange={(event) => editProfileHandler('WebsiteUrl', event)}

                                            label='  وبسایت (اختیاری) '


                                        />
                                    </Grid.Item>
                                    {getDataBaseB2B.UserType == 1 &&
                                        <Grid.Item
                                            size='col-6'>
                                            <TextField
                                                value={getDataBaseB2B.IATACode ? getDataBaseB2B.IATACode : ''}
                                                onChange={(event) => editProfileHandler('IATACode', event)}
                                                className={getDataBaseB2B.Confirmed == true ? 'disabled' : ''}
                                                disabled={getDataBaseB2B.Confirmed == true ? true : false}
                                                label='  کد IATA (اختیاری) '


                                            />
                                        </Grid.Item>
                                    }



                                    <Grid.Item

                                        className={`border-solid-bottom border-light`}
                                        size='col-12'>
                                        <Box
                                            onClick={() => toggleBox('first')}
                                            className={`w-100 pointer`}>
                                            <Typography ms={{
                                                fontWeight: 'bold'
                                            }}>
                                                اطلاعات تکمیلی
                                            </Typography>
                                            <Image
                                                className={`chevran-down`}
                                                ms={{
                                                    width: '20px !important',
                                                    height: '20px !important',
                                                    float: 'left',

                                                }}
                                                src={iconDownSVG} />

                                        </Box>


                                    </Grid.Item>
                                    <Box
                                        className={`first d-none w-100 float-left`}>
                                        <Grid.Wrapper>
                                            <Grid.Item
                                                size='col-6'>
                                                <TextField
                                                    value={getDataBaseB2B.Phone ? getDataBaseB2B.Phone : ''}
                                                    onChange={(event) => editProfileHandler('Phone', event)}
                                                    placeholder="0212345678"

                                                    label='  تلفن ثابت '


                                                />
                                            </Grid.Item>
                                            <Grid.Item
                                                size='col-6'>
                                                <TextField
                                                    value={getDataBaseB2B.Fax ? getDataBaseB2B.Fax : ''}
                                                    onChange={(event) => editProfileHandler('Fax', event)}
                                                    label='  فکس'
                                                    placeholder="0212345678"
                                                />
                                            </Grid.Item>

                                            <Grid.Item
                                                size='col-6'>

                                                <Select
                                                    onChange={(event) => editProfileHandler('Country', event)}

                                                    label='کشور'
                                                    search
                                                    init={getDataBaseB2B.Country ? getDataBaseB2B.Country : ''}
                                                    readonly>
                                                              <Select.Item
                                                                    key={0}
                                                                    value={0}>
                                                             کشور انتخاب کنید 
                                                                </Select.Item>
                                                    {

                                                        Country.map((obj, index) => {
                                                            return (
                                                                <Select.Item
                                                                    key={index}
                                                                    value={obj.id}>
                                                                    {obj.title}
                                                                </Select.Item>
                                                            )
                                                        })}
                                                </Select>
                                            </Grid.Item>
                                            <Grid.Item
                                                size='col-6'>
                                                <Select
                                                    onChange={(event) => editProfileHandler('State', event)}

                                                    label='استان'
                                                    search
                                                    init={getDataBaseB2B.State ? getDataBaseB2B.State : ''}
                                                    readonly>
                                                         <Select.Item
                                                                    key={0}
                                                                    value={0}>
                                                             استان انتخاب کنید 
                                                                </Select.Item>

                                                    {

                                                        states.map((obj, index) => {
                                                            return (
                                                                <Select.Item
                                                                    key={index}
                                                                    value={obj.id}>
                                                                    {obj.title}
                                                                </Select.Item>
                                                            )
                                                        })}
                                                </Select>
                                            </Grid.Item>
                                            <Grid.Item
                                                size='col-6'>
                                                <Select
                                                    onChange={(event) => editProfileHandler('City', event)}

                                                    label='شهر'
                                                    search
                                                    init={getDataBaseB2B.City ? getDataBaseB2B.City : ''}
                                                    readonly>
                                                         <Select.Item
                                                                    key={0}
                                                                    value={0}>
                                                             شهر انتخاب کنید 
                                                                </Select.Item>
                                                    {cities.map((obj, index) => {

                                                        return (
                                                            <React.Fragment
                                                                key={index}>
                                                                {obj.stateId === +getDataBaseB2B.State &&
                                                                    <Select.Item
                                                                        value={obj.id}>
                                                                        {obj.title}
                                                                    </Select.Item>
                                                                }
                                                            </React.Fragment>
                                                        )
                                                    })}
                                                </Select>
                                            </Grid.Item>

                                            <Grid.Item
                                                size='col-6'>
                                                <TextField
                                                    value={getDataBaseB2B.PostalCode ? getDataBaseB2B.PostalCode : ''}
                                                    onChange={(event) => editProfileHandler('PostalCode', event)}


                                                    label='  کدپستی '


                                                />
                                            </Grid.Item>
                                            <Grid.Item
                                                size='col-6'>
                                                <TextField
                                                    value={getDataBaseB2B.Address ? getDataBaseB2B.Address : ''}
                                                    onChange={(event) => editProfileHandler('Address', event)}


                                                    label='  آدرس '


                                                />
                                            </Grid.Item>
                                        </Grid.Wrapper>

                                    </Box>
                                </Grid.Wrapper>


                            </Grid.Item>
                            <Grid.Item
                                size='col-4'>
                                <Image
                                    src={profileImg}
                                    ms={{
                                        background: '#F5F5F7',
                                        borderRadius: '16px'

                                    }}
                                />
                            </Grid.Item>

                            <Grid.Item
                                size='col-12'>
                                <Button
                                    ms={{
                                        padding: '8px 20px'
                                    }}
                                    type="submit"
                                    className={``}
                                    variant='filled'
                                    color='primary'>
                                    ذخیره اطلاعات
                                </Button>
                                <Button
                                    ms={{
                                        padding: '8px 20px'
                                    }}
                                    onClick={() => resetForm()}
                                    className={`mx-md`}
                                    variant='outlined'
                                    color='primary'>
                                    انصراف
                                </Button>
                            </Grid.Item>


                        </Grid.Wrapper>
                    </Grid>

                </Box>
            </form>
            <>

                {(!Success && Errs) && Errs.map((err, index) => (
                    <Alert key={index} className={`alert ${alertStatus}`}
                        color={alertColor}
                        ms={{
                            bottom: index == 0 ? (index + 1) * 50 + 'px !important' : index * 50 + 'px !important'
                        }}>
                        {err}
                    </Alert>
                ))}

            </>
            {Success && <Alert
                className={`alert ${alertStatus}`}
                color={alertColor}
                ms={{
                    bottom: '75px !important'
                }} >
                {alert}


            </Alert>}

        </React.Fragment>
    )
}
export default BaseInfo;